import useDocumentScroll from "./useDocumentScroll";

export default useDocumentScroll;
